import { ArrowRight } from "lucide-react";
import { SIGNATURES } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Signature = () => (
  <section id="signature" data-testid="signature-section" className="bg-espresso-dark grain relative py-24 md:py-36">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
      <SectionHeading chapter="05" eyebrow="Signature Dishes" title="Taste That Gets" script="remembered." dark />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
        {SIGNATURES.map((d, i) => (
          <Reveal key={d.name} delay={(i % 3) * 0.1} className={i % 3 === 1 ? "lg:mt-16" : ""}>
            <div data-testid={`signature-dish-${d.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group">
              <div className="relative overflow-hidden aspect-[4/5]">
                <img
                  src={d.img}
                  alt={`${d.name} — signature dish by Momay Caterers`}
                  loading="lazy"
                  className="w-full h-full object-cover scale-110 group-hover:scale-100 transition-transform duration-[1.4s] ease-out"
                />
                <div className="absolute inset-0 bg-espresso/20 group-hover:bg-espresso/0 transition-colors duration-700" />
                <span className="absolute inset-3 border border-cream/0 group-hover:border-gold/50 transition-colors duration-500 pointer-events-none" />
              </div>
              <h3 className="mt-5 font-serif text-2xl text-cream group-hover:text-gold transition-colors duration-300">{d.name}</h3>
              <p className="mt-2 text-cream/55 text-sm font-light leading-relaxed">{d.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16 text-center">
        <button
          data-testid="signature-build-menu-btn"
          onClick={() => window.dispatchEvent(new Event("open-menu-builder"))}
          className="group inline-flex items-center gap-3 border border-gold text-gold px-10 py-5 text-xs md:text-sm tracking-[0.3em] uppercase hover:bg-gold hover:text-espresso transition-colors duration-300"
        >
          Build My Menu
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
